import { ajaxAuth } from "@tm/utils"
import { WebserviceUrl } from "@tm/data/webserviceUrls"
import { ExtendVoucherRequest, ExtendVoucherResponse } from "./models"

export async function extendVoucher(request: ExtendVoucherRequest) {
    const url = `${WebserviceUrl.DmsGsiConnect}/ExtendVoucher`

    return ajaxAuth<ExtendVoucherResponse>({
        method: "POST",
        url,
        body: request,
    })
}
